import React from "react";
import OfferCard from "../../Components/OfferCard";
import Image1 from "../../assets/Group 154.png";
import Image2 from "../../assets/Group 155.png";
import Image3 from "../../assets/Group 156.png";
import Image4 from "../../assets/back.png";

function OfferSection() {
  return (
    <div className="lg:px-20 px-10 ">
      <p className="font-bold text-4xl pt-10 text-center">What we offer?</p>
      <div className="flex md:flex-row flex-col lg:px-20 md:px-5 px-1   lg:space-x-32 md:space-x-10">
        <OfferCard
          img={Image1}
          title="Find media rates"
          des="Qui soluta quis libero laudantium facilis. Eum mollitia culpa. Aut inventore rerum itaque quisquam repellat. "
        />
        <OfferCard
          img={Image2}
          title="Plan media spend"
          des="Qui soluta quis libero laudantium facilis. Eum mollitia culpa. Aut inventore rerum itaque quisquam repellat. "
        />
        <OfferCard
          img={Image3}
          title="Buy media spots"
          des="Qui soluta quis libero laudantium facilis. Eum mollitia culpa. Aut inventore rerum itaque quisquam repellat. "
        />
      </div>
      <div className="lg:px-20 mt-20 flex lg:flex-row flex-col  justify-between items-center lg:space-x-40 space-x-1 leading-normal	 tracking-wider	">
        <div className=" w-full">
          {" "}
          <div className="font-bold text-4xl w-full">
            Use us to save yourself big money on advertising every year.
          </div>
          <p className="font-normal text-lg pt-10 leading-loose	pb-5">
            Qui soluta quis libero laudantium facilis. Eum mollitia culpa. Aut
            inventore rerum itaque quisquam repellat. Reiciendis fuga totam quo
            ut. Quibusdam ut eligendi eius est nulla consequatur porro sed enim.
          </p>
          <button className=" mt-5 bg-primary px-6 py-1 text-white rounded-full">
            Learn More
          </button>
        </div>

        <div className="w-full mt-5">
          <img src={Image4} className="h-full w-full" alt="ss" />
        </div>
      </div>
    </div>
  );
}

export default OfferSection;
